export const UnserviceableServiceLevelHeader = [
  {
    header: "Category",
    key: "Category",
  },
  {
    header: "OnTime",
    key: "OnTime",
  },
  {
    header: "Delayed",
    key: "Delayed",
  },
];

export const UnserviceableServiceLevelName = "Core Unit Service Level";

export const UnserviceableServiceLevelDetailHeaders = [
  {
    header: "Ref No",
    key: "Ref No",
  },
  {
    header: "Category",
    key: "Category",
  },
  {
    header: "Requested Pn",
    key: "Requested Pn",
  },
  {
    header: "Serviceable Pn",
    key: "Serviceable Pn",
  },
  {
    header: "Serviceable Sn",
    key: "Serviceable Sn",
  },
  {
    header: "Serviceable Awb",
    key: "Serviceable Awb",
  },
  {
    header: "Core Unit Pn",
    key: "Core Unit Pn",
  },
  {
    header: "Core Unit Sn",
    key: "Core Unit Sn",
  },
  {
    header: "Core Unit Awb",
    key: "Core Unit Awb",
  },
  {
    header: "Serviceable Forward Date",
    key: "Serviceable Forward Date",
  },
  {
    header: "Core Unit Forward Date",
    key: "Core Unit Forward Date",
  },
  {
    header: "Requested Delivery Date",
    key: "Requested Delivery Date",
  },
  {
    header: "Penalty Days",
    key: "Penalty Days",
  },
  {
    header: "CLP",
    key: "Clp",
  },
  {
    header: "RELIABILITY",
    key: "RELIABILITY",
  },
  {
    header: "Penalty Price",
    key: "Penalty Price",
  },
  {
    header: "Customer Po",
    key: "Customer Po",
  },
  {
    header: "Delayed",
    key: "Delayed",
  },
];

export const UnserviceableServiceLevelDetailHeadersTtUser = [
  ...UnserviceableServiceLevelDetailHeaders,
  {
    header: "Cargo Accepted Date (RCS)",
    key: "Cargo Accepted Date",
  },
  {
    header: "Cargo Accepted Location",
    key: "Cargo Accepted Location",
  },
  {
    header: "Cargo Departure Date (DEP)",
    key: "Cargo Departure Date",
  },
  {
    header: "Cargo Departure Location",
    key: "Cargo Departure Location",
  },
  {
    header: "Cargo Departure Flight",
    key: "Cargo Departure Flight",
  },
  {
    header: "Cargo Arrival Date (RCF)",
    key: "Cargo Arrival Date",
  },
  {
    header: "Cargo Arrival Location",
    key: "Cargo Arrival Location",
  },
  {
    header: "Cargo Arrival Flight",
    key: "Cargo Arrival Flight",
  },
  {
    header: "Transit Days (DEP→RCF)",
    key: "Transit Days",
  },
  {
    header: "Fwd→Arrival Days (Forward→RCF)",
    key: "Fwd→Arrival Days",
  },
  {
    header: "Waiting Days (Forward→RCS)",
    key: "Waiting Days",
  },
];

export const UnserviceableServiceLevelDetailName = "Core Unit Service Level Detail";
